<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} bác sĩ
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <b-row>
          <b-col md="12">
            <div class="text-right mb-2" style="display: flex;align-items: flex-start;justify-content: flex-end;flex-direction: row;width: 100%;">
                <el-upload
                    action
                    :auto-upload="false"
                    list-type="text"
                    :limit="mData.fileUploadOption.DSBacSiVien.limit"
                    :accept="mData.fileUploadOption.DSBacSiVien.accept"
                    :on-change="fn_uploadChangeDSBacSiVien"
                    :on-exceed="fn_uploadExceedDSBacSiVien"
                    :on-remove="fn_uploadRemoveDSBacSiVien"
                    :file-list="mData.fileUploadOption.DSBacSiVien.fileList"
                    :disabled="mData.viewMode == 'detail'"
                    style="display: inline-block;margin-right: 10px;"
                >
                    <el-button size="small" type="info" plain>
                        <i class="fa fa-upload" aria-hidden="true"></i>
                        Chọn file
                    </el-button>
                </el-upload>
                <b-link
                class="el-button el-button--info el-button--small is-plain"
                :href="aExtension.urlFilesTemplate.DSBacSiVien"
                >
                    <i class="fa fa-download"></i> Tải file mẫu
                </b-link>
                <el-button @click="fn_saveData" type="info" plain>
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    Lưu
                </el-button>
                <el-button @click="fn_clearRowError" type="info" plain>
                    <i class="fa fa-trash" aria-hidden="true"></i>
                    Xóa các dòng lỗi
                </el-button>
                <el-button @click="fn_writeExelErrorRow" type="info" plain>
                    <i class="fa fa-download"></i>
                    Xuất dữ liệu lỗi
                </el-button>
            </div>
          </b-col>
        </b-row>
        <el-table
          :data="mData.dataImport"
          border
          style="width: 100%;"
          max-height="500"
        >
          <el-table-column
            type="index"
            label="STT"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="last_name"
            label="Họ đệm"
            width="150"
            sortable
          >
          <template slot-scope="scope">
                <span :class="{error: scope.row.note != ''}">
                    {{scope.row.last_name}}
                </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="first_name"
            label="Tên bác sĩ"
            width="120"
            sortable
          >
          <template slot-scope="scope">
                <span :class="{error: scope.row.note != ''}">
                    {{scope.row.first_name}}
                </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="hospital_code"
            label="Mã bệnh viện"
            width="120"
          >
          <template slot-scope="scope">
                <span :class="{error: scope.row.note != ''}">
                    {{scope.row.hospital_code}}
                </span>
            </template>
          </el-table-column>
          <el-table-column prop="hospital_name" label="Bệnh viện" width="200">
              <template slot-scope="scope">
                <span :class="{error: scope.row.note != ''}">
                    {{scope.row.hospital_name}}
                </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="license_code"
            label="Chứng chỉ hành nghề"
            width="180"
            sortable
          >
          <template slot-scope="scope">
                <span :class="{error: scope.row.note != ''}">
                    {{scope.row.license_code}}
                </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="note"
            label="Ghi chú"
          >
            <template slot-scope="scope">
                <span :class="{error: scope.row.note != ''}">
                    {{scope.row.note}}
                </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import BacSiVienModel from "./BacSiVienModel";
import BacSiVienApi from "../../../moduleApi/BacSiVienApi";
import AuthService from "../../../service/AuthService";
import * as moment from "moment";
import { Buffer } from "buffer";
import mushroom from "../../../service/mushroom.api.def";
import { METHODS } from "http";
import JsonExcel from "vue-json-excel";
import ExtensionService from "../../../service/ExtensionService";
import DkkApi from "../../../moduleApi/DkkApi";

export default {
    components: {JsonExcel},
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      aExtension: ExtensionService,
      mData: {
        moduleName: "BacSi", //requied
        dataDefault: {
          listBenhVien: [],
        },
        dataImport: [],
        fileUploadOption: {
            DSBacSiVien: {
                limit: 1,
                accept: ".xlsx",
                dialogImageUrl: "",
                dialogVisible: false,
                fileList: []
            },
            configIndex:
            [
                {
                    index: 0,
                    code: "first_name",
                    name: "Tên"
                },
                {
                    index: 1,
                    code: "last_name",
                    name: "Họ đệm"
                },
                {
                    index: 2,
                    code: "hospital_code",
                    name: "Mã bệnh viện"
                },
                {
                    index: 3,
                    code: "license_code",
                    name: "Chứng chỉ hành nghề"
                }
            ]
        }
      },
    };
  },

  methods: {

    async fn_initData() {
      try {
        let body = {
          account: "tichhop",
          password: "tichhop",
        };
        let req = await fetch(`${mushroom.$using()}auth/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });
        let res = await req.json();
        let response = await DkkApi.getHospital(null, res.result.token);
        this.mData.dataDefault.listBenhVien = response.data && response.data.Data ? response.data.Data : [];
      } catch (err) {
        console.log(err);
      }
    },
    fn_changeToHospitalName(row) {
      let cache = this.mData.dataDefault.listBenhVien.find(
        (hos) => hos.HOSPITAL_CODE == row.hospital_code
      );
      if (cache && cache.HOSPITAL_NAME) {
        return cache.HOSPITAL_NAME;
      } else {
        return "";
      }
    },
    fn_uploadExceedDSBacSiVien(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.DSBacSiVien.limit} file`
      );
    },
    async fn_uploadChangeDSBacSiVien(file, fileList) {
      let valueFile = await MethodService.readExcel(file.raw);
      if (valueFile.length > 1) {
        this.fn_formatExcelRow(valueFile);
      } else {
        toastr.error("Dữ liệu trong file trống");
      }
    },

    fn_formatExcelRow(valueFile) {
      // merge từ index excel sang tên code: value
      var arrBacSiVien = [];
      $.each(valueFile, (iFile, elFile) => {
        let newObject = {};
        if (iFile > 0) {
            let note = [];
          $.each(elFile, (iFileItem, elFileItem) => {
            $.each(
              this.mData.fileUploadOption.configIndex,
              (iModel, elModel) => {
                if (iFileItem == elModel.index) {
                  newObject[elModel.code] = elFileItem ? elFileItem.trim() : "";
                  if (iFileItem == 0 && (!elFileItem || (elFileItem && elFileItem.trim() == "")))
                    {
                        note.push("Không có tên bác sĩ");
                    }
                    if (iFileItem == 2 && (!elFileItem || (elFileItem && elFileItem.trim() == "")))
                    {
                        note.push("Không có mã bệnh viện");
                    }   
                    if (iFileItem == 3 && (!elFileItem || (elFileItem && elFileItem.trim() == "")))
                    {
                        note.push("Không có mã chứng chỉ hành nghề");
                    }
                    if (iFileItem == 2 && elFileItem && elFileItem.trim() != "")
                    {
                        let cache = this.mData.dataDefault.listBenhVien.find(hospital => hospital.HOSPITAL_CODE == elFileItem);
                        if (cache)
                        {
                            newObject['hospital_name'] = cache.HOSPITAL_NAME;
                        }
                        else
                        {
                            note.push("Mã bệnh viện không chính xác");
                        }
                    }
                }
              }
            );
          });
          let cache = arrBacSiVien.filter(item => {
              return item.first_name == newObject.first_name && item.last_name == newObject.last_name && item.hospital_code == newObject.hospital_code && item.license_code == newObject.license_code;
          })
          if (cache.length > 0 && note.length == 0)
          {
              note.push("Dữ liệu trùng");
          }
            newObject['note'] = note.join(', ');
          arrBacSiVien.push(newObject);
        }
      });
      this.mData.dataImport = arrBacSiVien;
    },
    fn_uploadRemoveDSBacSiVien() {
        this.mData.dataImport = [];
    },
    async fn_saveData() {
        if (this.mData.dataImport.length == 0) {
            return toastr.warning("Không có dữ liệu để lưu");
        }
        else if (this.mData.dataImport.filter(item => {
            return item.note != "";
        }).length > 0)
        {
            return toastr.warning("Tồn tại dữ liệu lỗi. Không cho phép lưu");
        }
        else {
            try {
                let data = [];
                this.mData.dataImport.forEach(item => {
                    data.push({
                        first_name: item.first_name,
                        last_name: item.last_name,
                        hospital_code: item.hospital_code,
                        hospital_name: item.hospital_name,
                        license_code: item.license_code, 
                    });
                });
                let res = await BacSiVienApi.importExel(data);
                if (res.result && res.result.error && res.result.error.length > 0)
                {
                    if (res.result.error.length == this.mData.dataImport.length)
                    {
                        toastr.error("Lưu thất bại!")
                    }
                    else
                    {
                        toastr.warning("Đã lưu lại các bản ghi hợp lệ!")
                    }
                    this.mData.dataImport.map(item => {
                        let cache = res.result.error.filter(error => {
                            return error.last_name == item.last_name && error.first_name == item.first_name && item.hospital_code == error.hospital_code && error.license_code == item.license_code;
                        });
                        if (cache.length > 0)
                        {
                            item.note = cache[0].error_messages.join(', ');
                        }
                    });
                }
                else
                {
                    toastr.success("Lưu thành công!");
                    this.$router.push({name: "Admin-" + this.mData.moduleName + "-list"});
                }
            }
            catch(error) {
            }
        }
    },
    fn_clearRowError() {
        if (this.mData.dataImport.length == 0)
        {
            return toastr.warning("Không có dữ liệu");
        }
        let cache = this.mData.dataImport.filter(row => {
            return row.note != "";
        });
        if (cache.length == 0)
        {
            return toastr.warning("Không có dữ liệu lỗi");
        }
        this.mData.dataImport = this.mData.dataImport.filter(row => {
            return row.note == "";
        });
    },
    fn_writeExelErrorRow() {
        if (this.mData.dataImport.length == 0)
        {
            return toastr.warning("Không có dữ liệu");
        }
        let cache = this.mData.dataImport.filter(row => {
            return row.note != "";
        });
        if (cache.length == 0)
        {
            return toastr.warning("Không có dữ liệu lỗi");
        }
        MethodService.exportExcel(cache);
    },
  },

  //run after render view
  created() {
    this.fn_initData();
  },
  mounted() {
  },
};
</script>
<style scoped>
.error {
    color: red;
}
</style>
